module.exports = __webpack_public_path__ + "img/htcm_16.2030319f.jpg";